import { IStore } from "modules/types";

export const getFaq = ({ help }: IStore) => help.faq;
export const getHelpPages = ({ help }: IStore) => help.help_pages;